export default __webpack_public_path__ + "static/media/nodejs.007e99f6.png";